import { JsonObject, JsonProperty, Any } from "json2typescript";
import { SearchParams } from '../searchParams';

export type Roll = {
    date: string,
    data: {
        caseSessions: {
            court: string,
            circle: string,
            sessions: any[]
        }[] | null,
        expertSessions: {
            court: string,
            circle: string,
            sessions: any[]
        }[] | null
    }
};

export type NotedSession = {
    date: string,
    situation: string,
    data: {
        court: string,
        circle: string,
        sessions: any
    }[]
}

@JsonObject('Roll')
export class RollsSearchResult {
    @JsonProperty('noted_sessions', Any, true)
    notedSessions = null;

    @JsonProperty('roll', Any, true)
    roll: any = null;

    get mapRoll(): Roll[] {
        let result =
            Object.keys(this.roll).map((date) => {
                const caseSessions = this.roll[date].case_sessions;
                const expertSessions = this.roll[date].expert_sessions;
                return {
                    date,
                    data: {
                        caseSessions: caseSessions ? Object.keys(caseSessions).map(court => {
                            const circle = Object.keys(caseSessions[court])[0];
                            return {
                                court,
                                circle,
                                sessions: caseSessions[court][circle]
                            }
                        }) : null,
                        expertSessions: expertSessions
                    }
                };
            });
        return result
    }

    get mapNotedSessions(): NotedSession[] {
        // TODO: figure out why its not sorting by date like it is returned from backend
        let result = Object.keys(this.notedSessions).map((date) => {
            const situation = Object.keys(this.notedSessions[date])[0];
            const notedSessions = this.notedSessions[date][situation];
            return {
                date,
                situation,
                data: notedSessions ? Object.keys(notedSessions).map(court => {
                    const circle = Object.keys(notedSessions[court])[0];
                    return {
                        court,
                        circle,
                        sessions: notedSessions[court][circle]
                    }
                }) : null
            }
        })
        return result;
    }

}


@JsonObject('RollSearchParams')
export class RollSearchParams extends SearchParams {
    @JsonProperty('created_date_range_after', String, true)
    createdDateAfter = null;

    @JsonProperty('created_date_range_before', String, true)
    createdDateBefore = null;

    @JsonProperty('session_date_range_after', String, true)
    sessionDateAfter = null;

    @JsonProperty('session_date_range_before', String, true)
    sessionDateBefore = null;

    @JsonProperty('cause', [Number], true)
    cause = [];

    @JsonProperty('postpone_reason', String, true)
    postponeReason = null;

    @JsonProperty('note', [Number], true)
    note = [];

    @JsonProperty('court', [Number], true)
    court = [];

    @JsonProperty('circle', [Number], true)
    circle = [];

    @JsonProperty('lawyers', [Number], true)
    lawyers = [];

    @JsonProperty('clients', [Number], true)
    clients = [];

    @JsonProperty('opponents', [Number], true)
    opponents = [];

    @JsonProperty('case__sequence', Number, true)
    fileSeq = undefined;

    @JsonProperty('case__case_number', Number, true)
    fileNum = undefined;

    @JsonProperty('prev_session_range_after', String, true)
    prevDateAfter = null;

    @JsonProperty('prev_session_range_before', String, true)
    prevDateBefore = null;

    @JsonProperty('next_session_range_after', String, true)
    nextDateAfter = null;

    @JsonProperty('next_session_range_before', String, true)
    nextDateBefore = null;

    @JsonProperty('expert', [Number], true)
    expert = [];

    rollNumber = 0;
}